import {initElements} from "../define/shared"

export default function initLargeSplitBlock() {
    initElements(".large-split", block => {
        const scrollDown = block.querySelector('.scrollDown')

        scrollDown.addEventListener('click', () => {
            window.scrollTo({
                left: 0,
                top: block.offsetHeight,
                behavior: "smooth"
            })
        })
    })
}
